import { Html5QrcodeScanner } from 'html5-qrcode';
import { useEffect } from 'react';

const qrcodeRegionId = 'html5qr-code-full-region';

const createConfig = (props) => {
    let config = {};
    if (props.fps) {
        config.fps = props.fps;
    }
    if (props.qrbox) {
        config.qrbox = props.qrbox;
    }
    if (props.aspectRatio) {
        config.aspectRatio = props.aspectRatio;
    }
    if (props.disableFlip !== undefined) {
        config.disableFlip = props.disableFlip;
    }
    return config;
};

const QrCode = (props) => {
    useEffect(() => {
        let scanTimeout;
        const config = createConfig(props);
        const verbose = props.verbose === true;

        if (!props.qrCodeSuccessCallback) {
            throw 'qrCodeSuccessCallback is required callback.';
        }
        const html5QrcodeScanner = new Html5QrcodeScanner(qrcodeRegionId, config, verbose);
        html5QrcodeScanner.render(props.qrCodeSuccessCallback, props.qrCodeErrorCallback);

        const startScanTimeout = () => {
            const timeoutDuration = 120000;
            scanTimeout = setTimeout(() => {
                props.setShowScanner(false);
                props.setShowAlert(true);
            }, timeoutDuration);
        };

        const handleScanResult = (decodedText, decodedResult) => {
            clearTimeout(scanTimeout);
            props.qrCodeSuccessCallback(decodedText, decodedResult);
        };

        html5QrcodeScanner.onScanSuccess = handleScanResult;
        startScanTimeout();

        return () => {
            clearTimeout(scanTimeout);
            html5QrcodeScanner.clear().catch((error) => {
                console.error('Failed to clear html5QrcodeScanner. ', error);
            });
        };
    }, []);

    return <div id={qrcodeRegionId} />;
};

export default QrCode;
